export default {
    created: "Destinatarul WhatsApp a fost creat cu succes.",
    updated: "Destinatarul WhatsApp a fost actualizat cu succes.",
    deleted: "Destinatarul WhatsApp a fost sters cu succes.",
    restored: "Destinatarul WhatsApp a fost restaurat cu succes.",
    imported: "Destinarii WhatsApp au fost importati cu succes.",
    example_downloaded: "Exemplul destinarii WhatsApp a fost descarcat cu succes.",
}
